import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { EndpointService } from '@app/core';
import { ModeloBase } from '@app/shared';

@Injectable()
export class HeaderTitleTaskDataService {
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private api: EndpointService
  ) {}

  /**
   * Consulta las secundarias que se pueden iniciar desde el tramite actual
   *
   * @param {number} idTramite
   * @returns {Observable<ModeloBase[]>}
   * @memberof HeaderTitleTaskDataService
   */
  consultSecondary(idTramite: number): Observable<ModeloBase[]> {
    return new Observable(obs => {
      this.http
        .get<ModeloBase[]>(this.api.get('instanceSecondaryWorkflow', [idTramite])).subscribe(
          res => {
            obs.next(res);
          },
          err => {
            obs.error(err);
          }
        );
    });
  }

  /**
   * Inicia la carga de datos desde una tarea en especifico
   *
   * @param {number} idTask
   * @returns {Observable<boolean>}
   * @memberof HeaderTitleTaskDataService
   */
  initDataLoad(idTask: number): Observable<boolean> {
    return new Observable(obs => {
      const dataForm = {
        tarea: idTask
      };
      this.http
        .post<boolean>(this.api.get('dataCharge'), dataForm).subscribe(
          _res => {
            obs.next(true);
          },
          err => {
            obs.error(err);
          }
        );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/forms/shared/header-title-task/shared/header-title-task.data.service.ts